module.exports = __webpack_public_path__ + "img/czech-republic.79984b1b.png";